module.exports = __webpack_public_path__ + "static/media/logo-yes.18ec9721.png";